import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ByocPopupModule } from '@app/byoc';
import { ProfileAvatarModule } from '@app/profile';

import { MenuComponent } from './menu.component';
import { LogoutPopupComponent } from './logout/logout.component';
import { DataTestModule } from '@app/shared/directive/data-test';
import { ButtonComponent, ButtonOutlineComponent, ExternalLinkPopupDirective, IconComponent } from '@app/tw-shared/components';
import { MyLearningModalsModule } from '@app/shared/my-learning-modals/my-learning-modals.module';
import { ListDirective } from '@app/tw-shared/directives/list/list.directive';
import { ListItemDirective } from '@app/tw-shared/directives/list-item/list-item.directive';
import { PerfectScrollbarModule } from '@app/shared/perfect-scrollbar/perfect-scrollbar.module';
import { FormsCheckboxComponent } from '@app/tw-shared/forms/forms-checkbox/forms-checkbox.component';
import { PopupWrapperComponent } from '@app/shared/popup/components';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        TranslateModule,
        InlineSVGModule,
        ProfileAvatarModule,
        ByocPopupModule,
        DataTestModule,
        ButtonComponent,
        MyLearningModalsModule,
        IconComponent,
        ButtonOutlineComponent,
        ExternalLinkPopupDirective,
        ListDirective,
        ListItemDirective,
        PerfectScrollbarModule,
        FormsCheckboxComponent,
        PopupWrapperComponent,
    ],
    declarations: [MenuComponent, LogoutPopupComponent],
    exports: [MenuComponent],
})
export class HeaderMenuModule {}
